import CalendarItem from 'owa-service/lib/contract/CalendarItem';
import { action } from 'satcheljs';
import GetWeatherForecastResponse from 'owa-service/lib/contract/GetWeatherForecastResponse';

export const addCalendarItemsToStore = action(
    'ADD_CALENDAR_ITEMS_TO_STORE',
    (items: CalendarItem[]) => ({
        items,
    })
);

export const refreshCalendarEvents = action('REFRESH_CALENDAR_EVENTS');

export const loadWeatherForecast = action('LOAD_WEATHER_FORECAST');

export const addWeatherDailyConditionsToStore = action(
    'ADD_WEATHER_DAILY_CONDITIONS_TO_STORE',
    (weatherForecastResponse: GetWeatherForecastResponse) => ({
        weatherForecastResponse,
    })
);

export const hideAgenda = action('SET_IS_UPNEXT_AGENDA_OPEN');

export const toggleIsAgendaOpen = action('TOGGLE_IS_UPNEXT_AGENDA_OPEN');

export const startRefreshTimer = action('START_REFRESH_TIMER');

export const updateNextMeetingInformation = action(
    'UPDATE_NEXT_MEETING_INFORMATION',
    (nextMeeting: CalendarItem) => ({
        nextMeeting,
    })
);
